import {createTheme} from '@mui/material'

const semiDarkTheme = createTheme({
  palette: {
    primary: {
      contrastText: "#fff",
      main: '#f68f3f'
    },
    secondary: {
      contrastText: "#fff",
      main: "#6091AB",
    },
    background: {
      main: '#ffffff',
      mainDarker2: '#f9f9f9',
      mainDarker5: '#f2f2f2',
      dark: '#f2f4f4'
    },
    backgroundDark: {
      main: '#1a233a',
      dark: '#161e31',
      light: '#2d3651',
      contrastText: '#fff'
    },
    menu: {
      background: {
        main: '#1a233a',
        dark: '#0a0a1e'
      }
    }
  },
  shape: { borderRadius: 5 },
});

export default semiDarkTheme